import React from "react";
import DatePicker from "react-datepicker";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./DatePicker.css";
const CustomHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => {
  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" })
  );
  return (
    <div className="custom-header">
      <div className="month-navigation">
        <button
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          className="month-nav-btn"
        >
          <ChevronLeft size={16} />
        </button>

        <select
          value={date.getMonth()}
          onChange={({ target: { value } }) => changeMonth(parseInt(value))}
          className="month-select"
        >
          {months.map((month, index) => (
            <option key={month} value={index}>
              {month}
            </option>
          ))}
        </select>

        <button
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          className="month-nav-btn"
        >
          <ChevronRight size={16} />
        </button>
      </div>

      <select
        value={date.getFullYear()}
        onChange={({ target: { value } }) => changeYear(parseInt(value))}
        className="year-select"
      >
        {Array.from({ length: 10 }, (_, i) => date.getFullYear() - 5 + i).map(
          (year) => (
            <option key={year} value={year}>
              {year}
            </option>
          )
        )}
      </select>
    </div>
  );
};

const CustomDatePicker = ({
  selectedDate,
  setSelectedDate,
  setIsDatePickerOpen,
}) => {
  return (
    <div className="date-picker-popup">
      <DatePicker
        selected={selectedDate}
        onChange={(date) => {
          setSelectedDate(date);
          setIsDatePickerOpen(false);
        }}
        inline
        renderCustomHeader={CustomHeader}
        showMonthYearPicker={false}
        showFullMonthYearPicker={false}
        showTwoColumnMonthYearPicker={false}
        showFourColumnMonthYearPicker={false}
        showDateMonthYear={true}
        onClickOutside={() => setIsDatePickerOpen(false)}
      />
    </div>
  );
};

export default CustomDatePicker;
